import Stop from "../classes/Stop.js";
import trainData from '../data/hinotama-RAIL-Stop.json';
import busData from '../data/hinotama-BUS-Stop.json';
import { formatTime } from "../utils/timeUtils.js";
const maxTimestamp = 60 * 60 * 24; // 最大のタイムスタンプ
const ratioOfBUffer = 0.1; // 菌の半径に対してどれほど透明部分をつけるか？（0.1 -> 半径の10%分周りに透明部分をつける．）
const dataList = [trainData,busData]
const trainDatas = dataList.flat(); // データ統合

/**
 * 菌を管理するクラス
 * 基本的にcurrentTimestampを外部から受け取ることで，菌の動きをシミュレートする．
 * 指定されたcurrentTimestampでの菌の状態を返す．
 */
class BacteriaManager {
    /**
     * @param {number} currentTimestamp 現在時刻
     */
    #lastTimestamp;
    constructor(currentTimestamp){
        this.currentTimestamp = currentTimestamp;
        this.#lastTimestamp = currentTimestamp; // ひとつ前の更新時刻を覚える
        BacteriaManager.#initializeStops(currentTimestamp).then((stops) => { // jsonからStopインスタンスを生成
            this.stops = stops;
        });      
    };

    /**
     * 外部タイマーに依存したシミュレーション実行
     * @param {number} currentTimestamp 秒のタイムスタンプ
     */
    run(currentTimestamp){
        /** まず前回の更新からの差分時間を計算する */
        let diffSec = currentTimestamp - this.#lastTimestamp;
        if (diffSec < 0){ // 日付超過への対応
            diffSec = maxTimestamp - this.#lastTimestamp;
            diffSec += currentTimestamp;
        }
        // Stopへの処理
        this.stops.map((stop) => {
            stop.checkArrival(currentTimestamp); // 栄養到達処理
            stop.bacterias.forEach((bacteria) => {
                bacteria.metabolize(diffSec); // 代謝
                bacteria.weaken(); // 衰弱
                
                stop.binaryFission(bacteria); // 細胞分裂
                stop.die(bacteria); // 自然死チェック
                stop.naturalSelection(); // 自然淘汰

            })
        })
        // 前回のタイムスタンプの更新
        this.#lastTimestamp = currentTimestamp;
    }


    /**
     * すべてのStopからすべての菌を取得する．
     * @returns 菌
     */
    #getBacterias(){
        if (this.stops.length === 0){ return []; }
        const allBacterias = [];
        this.stops.map((stop) => {
            allBacterias.push(...Array.from(stop.bacterias));
        })
        return allBacterias;
    }

    /**
     * 可視化するオブジェクトを取得して指定のデータ形式で返す．
     * ここに描画範囲にフィルタリングする処理描いた方がいい？
     * @returns 可視化するオブジェクト
     */
    getVisualizingObjects(){
        const visualizingObjects = [];
        const bacterias = this.#getBacterias(); // 最新の全バクテリアを取得

        if (bacterias.length !== 0) {
            bacterias.forEach((bacteria) => {
            if (bacteria.healtPoints > 30) console.log("大きすぎるbacteria",bacteria);
              // 1. 菌の色が塗られている部分
              const fillObj = {
                lat     : bacteria.lat,
                lng     : bacteria.lng,
                r       : bacteria.R,
                color   : bacteria.route_color,
                opacity : bacteria.opacity,
                type    : "fill"
              }
              visualizingObjects.push(fillObj);
              // 2. 菌の周りの透明なバッファ（切り抜くとこ）
              const transparentObj = {
                lat     : bacteria.lat,
                lng     : bacteria.lng,
                r       : bacteria.R * (1+ratioOfBUffer), // 菌の半径より指定分大きくする．
                color   : bacteria.route_color,
                opacity : bacteria.opacity,
                type    : "none"
              }
              visualizingObjects.push(transparentObj);
            });
          }
        return visualizingObjects;
    }

    /**
     * Stopを初期生成する
     * @param {number} currentTimestamp 現在時刻（シミュレーション開始時刻）
     * @returns Stops
     */
    static async #initializeStops(currentTimestamp) {
        try {
            const initializedStops = trainDatas.map((trainData) => {
                const generatedStop = new Stop(
                    trainData.stop_lat,
                    trainData.stop_lon,
                    trainData.stop_id,
                    trainData.stop_name,
                    trainData.route_id,
                    trainData.route_name,
                    trainData.route_color,
                    trainData.route_type,
                    trainData.timestamps,
                    currentTimestamp
                );
                generatedStop.simulate(); // 内部のシミュレーション開始
                return generatedStop;
            });
            console.log("jsonファイルの読み込みが完了しました．");
            return initializedStops;
        } catch (error) {
            console.error("jsonファイルの読み込みに失敗しました．:", error);
            return [];
        }
    }
}

export default BacteriaManager;


